import styled from '@emotion/styled';
export const UnorderedList = styled.ul `
	list-style: none;
	padding: 0;
	margin: 0;

	${props => props.outerRadius && `
		li:first-of-type {
			border-top-left-radius: ${props.outerRadius - 1}px;
			border-top-right-radius: ${props.outerRadius - 1}px;
		}
		li:last-of-type {
			border-bottom-left-radius: ${props.outerRadius - 1}px;
			border-bottom-right-radius: ${props.outerRadius - 1}px;
		}
	`};
`;
//# sourceMappingURL=ListGroup.styled.js.map